import { render } from "./RedbookUserMessage.vue?vue&type=template&id=57a45583&scoped=true"
import script from "./RedbookUserMessage.vue?vue&type=script&lang=js"
export * from "./RedbookUserMessage.vue?vue&type=script&lang=js"

import "./RedbookUserMessage.vue?vue&type=style&index=0&id=57a45583&lang=less&scoped=true"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a45583"]])

export default __exports__